/**
 * Documents in the command palette know their scope (cards 1.3 / 5.4): the
 * key a document's scope has in the Documents sidebar's switcher, and the
 * badge a result shows when it lives in another scope than the one the
 * sidebar shows. Pure.
 */

/**
 * `personal` | `personal/<id>` | `device` | `team:<id>` — the sidebar's scope
 * keys (documentsUiStore.scopeKey); a workspace is `personal/<id>` (card 5.4).
 */
export function docScopeKey(scope) {
  if (scope?.type === 'team' && scope.teamId != null) return `team:${scope.teamId}`;
  if (scope?.type === 'device') return 'device';
  if (scope?.scopeId) return `personal/${scope.scopeId}`;
  return 'personal';
}

/** The badge text for a document item, or null when it is in the sidebar's current scope. */
export function docScopeBadge(item, currentKey, teams, t) {
  if (item?.type !== 'document') return null;
  const key = docScopeKey(item.payload?.scope);
  if (key === (currentKey || 'personal')) return null;
  if (key === 'personal') return t('docSidebar.scope.personal');
  if (key === 'device') return t('cloudLocal.deviceSection.title');
  if (key.startsWith('personal/')) return item.payload?.scopeName || t('docSidebar.scope.workspace');
  const team = (teams || []).find((tm) => `team:${tm?.id}` === key);
  return team?.name || t('docSidebar.scope.team');
}
